import { FormControl, Grid, InputLabel, MenuItem, Select, Typography, } from '@mui/material';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import DownloadButton from '../../../molecules/DownloadButton';
var years = Array.from({ length: 10 }, function (_, i) { return 2021 + i; });
var months = Array.from({ length: 12 }, function (_, i) { return i + 1; });
var PendingWarehouseFees = function () {
    var t = useTranslation().t;
    var _a = useState(''), year = _a[0], setYear = _a[1];
    var _b = useState(''), month = _b[0], setMonth = _b[1];
    var isDownloadEnabled = year !== '' && month !== '';
    var filename = year && month
        ? "pending_warehouse_fee_".concat(year).concat(month.padStart(2, '0'), ".csv")
        : 'pending_warehouse_fee.csv';
    return (React.createElement(Grid, { container: true, spacing: 3 },
        React.createElement(Grid, { item: true, xs: 12 },
            React.createElement(Typography, { variant: "h2", component: "h2", gutterBottom: true }, t('admin.exportCsv.pendingWarehouseFee.title'))),
        React.createElement(Grid, { item: true, xs: 6, md: 3 },
            React.createElement(FormControl, { fullWidth: true },
                React.createElement(InputLabel, { id: "pending-year-select-label" }, "Year"),
                React.createElement(Select, { labelId: "pending-year-select-label", value: year, label: "Year", onChange: function (e) { return setYear(e.target.value); } }, years.map(function (y) { return (React.createElement(MenuItem, { key: y, value: y.toString() }, y)); })))),
        React.createElement(Grid, { item: true, xs: 6, md: 3 },
            React.createElement(FormControl, { fullWidth: true },
                React.createElement(InputLabel, { id: "pending-month-select-label" }, "Month"),
                React.createElement(Select, { labelId: "pending-month-select-label", value: month, label: "Month", onChange: function (e) { return setMonth(e.target.value); } }, months.map(function (m) { return (React.createElement(MenuItem, { key: m, value: m.toString() }, m)); })))),
        React.createElement(Grid, { item: true, xs: 12 },
            React.createElement(DownloadButton, { title: t('admin.exportCsv.labels.downloadButton'), path: "/api/admin/export_csv/pending_warehouse_fees", downloadFilename: filename, params: { year: year, month: month }, size: "medium", disabled: !isDownloadEnabled }))));
};
export default PendingWarehouseFees;
